/* 是不需登陆便可跳转的页面，例如登录，浏览器版本提醒等 */
import routerMap from '../routerMap.js';
/* 注：meta里的hidden属性，是判断在不在tab选项卡是否显示 */
// 路由白名单
var constRouters = [
  {
    path: '/login',
    name: 'login',
    component: routerMap.login,
    meta:{
      title:"登录页",
      hidden:true,
      tpl:"noMain"
    },
  },
  {
    path:"/404",
    name:"404",
    component:routerMap.notFind,
    meta:{
      title:"404页",
      hidden:true
    }
  },
  {
    path:"/500",
    name:"500",
    component:routerMap.errorServer,
    meta:{
      title:"服务器错误",
      hidden:true
    }
  },
  {
    path:"/noauth",
    name:"no-auth-user",
    component:routerMap.noAuthUser,
    meta:{
      title:"用户未授权",
      hidden:true
    }
  },
  {
    path:"/tab",
    name:"demo-tab",
    component:() => import('views/demo/table'),
    meta:{
      title:"表格测试",
      hidden:true     
    }
  },
  {
    path:"/browserVersionReminder",
    name:"browser",
    component: routerMap.browserVersionReminder,
    meta:{title:"浏览器版本提醒",hidden: true,tpl:"noMain"}
  }
]
export default constRouters
